var _circle, _path, _path2, _path3, _path4, _path5, _path6, _mask, _rect, _rect2, _path7, _circle2, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _path18, _ellipse2, _path19, _ellipse3, _rect3, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScanSplash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 290,
    viewBox: "0 0 300 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.407,
    cy: 147.492,
    r: 104.492,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8644 56.7288H97.7796",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8644 62.0678H97.7796",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8644 75.7966H97.7796",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8644 81.1356H97.7796",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8644 94.8644H97.7796",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8644 100.203H97.7796",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_7442_61922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.644,
    y: 74.2712,
    width: 7.62712,
    height: 7.62712,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.644,
    y: 74.2712,
    width: 7.62712,
    height: 7.62712,
    rx: 1,
    stroke: "#424243",
    strokeWidth: 4,
    mask: "url(#path-8-inside-1_7442_61922)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.644,
    y: 94.339,
    width: 5.62712,
    height: 5.62712,
    stroke: "#424243",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.263 58.6356L107.314 61.6864L113.034 55.9661",
    stroke: "#0091F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7442_61922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 43,
    width: 210,
    height: 209
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.407,
    cy: 147.492,
    r: 104.492,
    fill: "#F6F6F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7442_61922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.594 207.166L166.949 195.542L121.949 195.924L91.0748 206.215C79.5573 210.054 70.556 219.148 66.8346 230.704L65.5084 234.822L155.5 263L222.627 245.5C222.627 245.5 228.609 248.633 217.678 225.359C213.698 216.884 206.348 210.487 197.594 207.166Z",
    fill: "white",
    stroke: "#424243",
    strokeWidth: 2
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.33 195.924C127.87 193.073 128.978 188.108 126.906 179.525L142.5 187L151.313 187.534L160.084 183.339C159.214 190.245 160.466 193.254 166.949 195.542C164.814 206.653 162.134 211.619 155.913 218.53C153.681 221.009 150.028 221.62 147.098 220.025C134.369 213.096 128.555 207.23 122.33 195.924Z",
    fill: "white",
    stroke: "#424243",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 133L108.5 134L135 111.5L178.5 125L179.5 131.5L178.5 143.5L177.5 147.5V153L175.5 163.5L171 172.5L161.5 182.5L150.5 188L141.5 187L124.5 178L116 168.5L110 153H105L102 143.5L103 134L106.5 133Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M217.5 137.569L154.746 186.771C142.487 186.771 129 177 123 169C105.641 142.09 112.726 96.3174 172 111L217.5 120.5V137.569Z",
    fill: "url(#paint0_linear_7442_61922)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.84 126.04C130.257 123.222 135.16 122.436 140.111 123.176C148.551 124.438 153.475 132.849 154.628 141.304L156.857 157.653C156.982 158.569 156.27 159.384 155.346 159.384H145.413",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.558 136.731C132.275 133.858 136.043 133.871 142.76 136.731",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.094 136.731C164.811 133.858 168.579 133.871 175.296 136.731",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.57 135.558C168.211 135.448 169.761 135.667 172.306 136.345L172.329 136.168C172.394 136.44 172.429 136.723 172.429 137.015C172.429 138.994 170.825 140.598 168.845 140.598C166.866 140.598 165.262 138.994 165.262 137.015C165.262 136.496 165.372 136.003 165.57 135.558Z",
    fill: "#424243"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.504 134.783C133.016 135.396 132.725 136.171 132.725 137.015C132.725 138.994 134.329 140.599 136.308 140.599C138.288 140.599 139.892 138.994 139.892 137.015C139.892 136.515 139.79 136.039 139.605 135.607C137.35 134.979 135.855 134.748 133.504 134.783Z",
    fill: "#424243"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.4 170.852C150.258 172.927 154.043 172.593 160.319 170.852",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.072 134.656C119.823 131.789 126.632 126.055 136.308 113.871C148.493 122.83 161.395 126.772 175.371 129.639L181.464 130.356C178.238 99.5357 166.054 86.9926 141.326 85.2007C114.448 89.1428 104.772 105.27 104.771 132.864C106.992 132.442 107.638 132.864 109.072 134.656Z",
    fill: "#424243",
    stroke: "#424243",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.032,
    cy: 111.106,
    rx: 7.85599,
    ry: 10.8112,
    transform: "rotate(-35 112.032 111.106)",
    fill: "#424243"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M178.955 142.899L179.951 142.982L178.955 142.899ZM160.223 183.568L159.592 182.792L160.223 183.568ZM142.22 90.5945L142.16 91.5927L142.22 90.5945ZM139.614 185.979L140.033 185.071L139.614 185.979ZM111.133 149.541C111.041 148.997 110.525 148.63 109.98 148.722C109.436 148.814 109.069 149.33 109.161 149.875L111.133 149.541ZM103.688 133.518L104.224 134.362H104.224L103.688 133.518ZM102.475 135.258L101.52 134.96H101.52L102.475 135.258ZM105.191 153.091L105.756 152.266H105.756L105.191 153.091ZM177.958 142.816C176.998 154.409 175.252 162.054 172.352 167.957C169.462 173.841 165.385 178.079 159.592 182.792L160.855 184.344C166.751 179.546 171.075 175.092 174.147 168.839C177.208 162.607 178.983 154.673 179.951 142.982L177.958 142.816ZM142.16 91.5927C156.599 92.4695 166.144 96.8222 171.793 104.999C177.483 113.235 179.386 125.576 177.958 142.816L179.951 142.982C181.39 125.606 179.531 112.682 173.439 103.863C167.306 94.985 157.05 90.4932 142.281 89.5963L142.16 91.5927ZM140.033 185.071C130.291 180.574 124.029 177.025 119.714 171.985C115.418 166.969 112.962 160.365 111.133 149.541L109.161 149.875C111.012 160.825 113.547 167.859 118.195 173.286C122.822 178.69 129.454 182.39 139.194 186.887L140.033 185.071ZM106.963 132.874C107.072 120.996 108.834 110.24 114.044 102.687C119.188 95.2304 127.823 90.722 142.16 91.5927L142.281 89.5963C127.41 88.6933 118.025 93.3935 112.397 101.552C106.835 109.615 105.073 120.88 104.963 132.855L106.963 132.874ZM109.508 133.608C108.08 131.738 105.333 131.287 103.151 132.674L104.224 134.362C105.604 133.485 107.172 133.845 107.919 134.822L109.508 133.608ZM101.52 134.96C100.315 138.822 100.337 142.997 100.995 146.437C101.325 148.16 101.82 149.726 102.42 150.998C103.007 152.243 103.746 153.314 104.625 153.916L105.756 152.266C105.308 151.96 104.757 151.266 104.229 150.145C103.713 149.051 103.264 147.65 102.96 146.061C102.35 142.875 102.341 139.042 103.429 135.556L101.52 134.96ZM104.625 153.916C107.546 155.917 110.295 153.807 110.962 153.465L110.048 151.686C108.831 152.311 107.457 153.432 105.756 152.266L104.625 153.916ZM103.151 132.674C102.266 133.237 101.777 134.136 101.52 134.96L103.429 135.556C103.606 134.99 103.881 134.58 104.224 134.362L103.151 132.674ZM159.592 182.792C154.121 187.245 146.473 188.045 140.033 185.071L139.194 186.887C146.292 190.164 154.76 189.303 160.855 184.344L159.592 182.792Z",
    fill: "#424243"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.349,
    cy: 85.9175,
    rx: 15.0517,
    ry: 10.3929,
    transform: "rotate(-15 127.349 85.9175)",
    fill: "#424243"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.977 85.0555C127.483 85.3025 127.283 85.9032 127.53 86.3972C127.777 86.8911 128.378 87.0914 128.871 86.8444L127.977 85.0555ZM128.871 86.8444C132.278 85.141 136.299 84.2144 142.503 84.2331L142.509 82.2331C136.088 82.2137 131.738 83.1752 127.977 85.0555L128.871 86.8444Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.735,
    cy: 96.5073,
    rx: 10.8564,
    ry: 9.70238,
    transform: "rotate(-51.7823 113.735 96.5073)",
    fill: "#424243"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 217.483,
    y: 112.322,
    width: 35.0847,
    height: 70.9322,
    rx: 4.57627,
    fill: "#424243"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M223.563 182.713C225.298 189.291 226.554 194.053 228.132 196.943L228.162 196.997C229.218 198.931 230.381 201.062 230.086 203.241C228.343 216.106 222.096 227.405 216.72 235.5L246 233C247.515 222.643 249.82 211.547 251.423 199.653L255.395 161.381C255.539 159.989 255.205 158.586 254.419 157.427C247.927 147.856 239.848 138.739 236.5 136C234.554 134.408 232.496 133.264 230.401 132.403C227.525 131.221 225.564 135.181 227.803 137.338C231.549 140.945 234.094 143.793 235 145C239.163 150.551 241.392 153.917 244.94 160.373C237.892 154.042 232.588 149.603 225 145C222.194 143.653 219.579 142.568 216.819 141.703C213.9 140.787 212.361 144.348 214.755 146.253C218.323 149.091 222.003 152.136 226.254 155.797C229.999 159.253 232.51 162.088 237.313 168.381L218.145 159.045C217.026 158.5 215.687 159.098 215.346 160.294L214.805 162.192C214.58 162.981 214.862 163.829 215.512 164.329C225.372 171.903 228.45 174.464 230.449 176.771C225.042 174.067 222.001 172.74 218.016 171.244C216.929 170.836 215.73 171.45 215.412 172.566L214.849 174.544C214.602 175.409 214.964 176.332 215.732 176.8L222.154 180.709C222.827 181.119 223.316 181.775 223.517 182.538L223.563 182.713Z",
    fill: "white",
    stroke: "#424243",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212 231.169V251H259V223L221.635 223C218.593 225.911 215.376 228.639 212 231.169Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7442_61922",
    x1: 153.5,
    y1: 84.5,
    x2: 208.5,
    y2: 194.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916277,
    stopColor: "#C1E6FF",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScanSplash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scan_splash.a1ba1c68736039f65d5a61526f622308.svg";